/**
 * @generated SignedSource<<f39fdad8ff872881c079d69de18114ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InviteCodePreviewDialog_inviteCode$data = {
  readonly code: string;
  readonly " $fragmentType": "InviteCodePreviewDialog_inviteCode";
};
export type InviteCodePreviewDialog_inviteCode$key = {
  readonly " $data"?: InviteCodePreviewDialog_inviteCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"InviteCodePreviewDialog_inviteCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InviteCodePreviewDialog_inviteCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "type": "InviteCode",
  "abstractKey": null
};

(node as any).hash = "c0e4859468a89b9ca7b09d6841c3fb73";

export default node;
